import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { addAMPAnalytics as addAMPAnalyticsAction } from '../amp/actions';
import { Tooltip } from '../generic/idcta/Tooltip';

if (process.env.CLIENT) {
  require('./AddToFavourites.scss'); // eslint-disable-line global-require
}

const FavouriteStatus = ({ className, text }) => (
  <div>
    <span className={className} />
    <input
      className="recipe-actions-link__button gel-long-primer"
      type="submit"
      value={`${text}`}
    />
  </div>
);

FavouriteStatus.propTypes = {
  className: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

const Statuses = {
  Added: () => (
    <FavouriteStatus className="recipe-actions__added-favourites-icon" text="Added to favourites" />
  ),
  AddToFavourites: () => (
    <FavouriteStatus className="recipe-actions__add-favourites-icon" text="Add to favourites" />
  ),
  Loading: () => (
    <FavouriteStatus className="recipe-actions__adding-favourites-icon" text="Loading" />
  ),
};

const FormStatus = ({ children, status }) => (
  <div className="hidden" data-amp-bind-class={`formStatus == '${status}' ? '' : 'hidden'`}>
    {children}
  </div>
);

FormStatus.propTypes = {
  children: PropTypes.node.isRequired,
  status: PropTypes.string.isRequired,
};

export class AddToFavouritesAMP extends PureComponent {
  constructor(props) {
    super(props);

    // If there are any other amp-forms on the page this might conflict in the future
    this.props.addAMPAnalytics({
      actionName: 'add-to-fav',
      actionType: 'added',
      on: 'amp-form-submit',
    });
  }

  render() {
    const { baseURL, recipeId, registerUrl, signInUrl } = this.props;

    return (
      <div className="recipe-actions-wrap gel-layout__item gel-1/1 gel-1/2@m">
        <div className="my-favourites-recipes__start-adding recipe-actions-text--button">
          <section amp-access="loggedIn = false" amp-access-hide="true">
            <span className="recipe-actions__add-favourites-icon" />
            <span
              className="recipe-actions-link__button gel-long-primer"
              on="tap:AMP.setState({ shouldShowTooltip: 'true' })"
              role="button"
              tabIndex="0"
            >
              Add to favourites
            </span>

            <Tooltip
              idctaInit={{
                html: `
              <p>
                <a class="cta-tooltip__sign-in" href="${signInUrl}">Sign in</a>
                or
                <a class="cta-tooltip__register" href="${registerUrl}">Register</a>
              </p>`,
              }}
              idctaPath=""
              isAMP
              subtitle="Want to make this later? Sign in to add it to your favourites."
              onClose={() => {}}
            />
          </section>

          <section amp-access="loggedIn AND NOT favourited" amp-access-hide="true">
            <form
              action-xhr={`${baseURL}/food/favourites/recipe/amp`}
              method="post"
              on="submit:AMP.setState({ formSubmitted: 'true' });submit-success:AMP.setState({ formStatus: 'success' });submit-error:AMP.setState({ formStatus: 'error' })"
              target="_top"
            >
              <div submit-success="true">
                <Statuses.Added />
              </div>
              <div submit-error="true">
                <Statuses.AddToFavourites />
              </div>

              <span data-amp-bind-class="formSubmitted == 'true' ? 'hidden' : ''">
                <input name="recipeId" type="hidden" value={recipeId} />
                <Statuses.AddToFavourites />
              </span>
            </form>
          </section>

          <section amp-access="favourited" amp-access-hide="true">
            <Statuses.Added />
          </section>
        </div>
        <p
          className="my-favourites-recipes__start-adding--error gel-brevier hidden"
          data-amp-bind-class="formStatus == 'error' ? '' : 'hidden'"
        >
          Unfortunately we are unable to add this recipe to your favourites, please try again later.
        </p>
      </div>
    );
  }
}

AddToFavouritesAMP.propTypes = {
  addAMPAnalytics: PropTypes.func.isRequired,
  baseURL: PropTypes.string.isRequired,
  recipeId: PropTypes.string.isRequired,
  registerUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
};

export default connect(
  ({ pageReducer }) => ({
    baseURL: pageReducer.baseURL,
    registerUrl: pageReducer.registerUrl,
    signInUrl: pageReducer.signInUrl,
  }),
  {
    addAMPAnalytics: addAMPAnalyticsAction,
  }
)(AddToFavouritesAMP);
